import NexMonitorScreen from './NexMonitorScreen';
export default NexMonitorScreen;
